import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CompensationMethodMatchType } from "@redotech/redo-return-core-common/return-flow/condition-enums";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  compensationMethodFromModel,
  validateCompensationMethodCondition,
  type CompensationMethodState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";
import { getLabelForReturnOption } from "./return-method";

export const COMPENSATION_METHOD = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<CompensationMethodState>
  >,
): ConditionType<CompensationMethodState, Condition.CompensationMethod> => ({
  name: CONDITION_NAMES[Condition.COMPENSATION_METHOD],
  description(state) {
    if (state.compensationMethods.length === 0) {
      return t("No compensation methods selected");
    }
    const labels = state.compensationMethods
      .map((method) => getLabelForReturnOption(method))
      .join(", ");
    return state.matchType === CompensationMethodMatchType.ALL
      ? t("Compensation method is all of {{labels}}", { labels })
      : t("Compensation method contains {{labels}}", { labels });
  },
  Details(props: ConditionTypeDetailsProps<CompensationMethodState>) {
    return React.createElement(Details, props);
  },
  empty: {
    compensationMethods: [],
    matchType: CompensationMethodMatchType.CONTAINS,
  },
  fromModel(model) {
    return compensationMethodFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.COMPENSATION_METHOD,
      compensationMethods: state.compensationMethods,
      matchType: state.matchType,
    };
  },
  valid(state) {
    return validateCompensationMethodCondition(state).valid;
  },
});
